import React from 'react';
import '@babel/polyfill';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { theme } from 'assets/theme';
import 'circe/lib/reporting/tables/style.css';
import Amplify, { Storage } from 'aws-amplify';
import 'url-search-params-polyfill';
import { StoreContext } from 'redux-react-hook';
import Perfume from 'perfume.js';
import ttiPolyfill from 'tti-polyfill';
import ReactGA from 'react-ga4';
import Logger from 'circe/logger';
import 'domain/fuse/firebase';
import I18nProviderRedux from 'circe/I18n/ProviderRedux';
import { SnackbarProvider } from 'notistack';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import history from './store/history';
import App from './App';
import store from './store';
import ThemeProvider from './ThemeProvider';
import { locales, messages } from './locales';

require('es6-promise/auto');

export const configLocal = {
  identityPoolId: AWS_IDENTITY_POOL_ID, // REQUIRED - Amazon Cognito Identity Pool ID
  region: AWS_REGION, // REQUIRED - Amazon Cognito Region
  userPoolId: AWS_USER_POOL_ID, // OPTIONAL - Amazon Cognito User Pool  ID
  userPoolWebClientId: AWS_USER_POOL_WEB_CLIENT_ID, // OPTIONAL - Amazon Cognito Web Client ID
  Analytics: {
    // OPTIONAL - disable Analytics if true
    disabled: true,
  },
};

Amplify.configure(configLocal);

Storage.configure({
  AWSS3: {
    bucket: DRIVER_BUCKET_NAME,
  },
});

const currentStore = store({}, { history });

const tagManagerArgs = {
  gtmId: GOOGLE_TAG_MANAGER_ID,
};
window.store = {
  getState: currentStore.getState,
  dispatch: currentStore.dispatch,
};

ReactDOM.render(
  <Provider store={currentStore}>
    <SnackbarProvider maxSnack={10}>
      <StoreContext.Provider value={currentStore}>
        <I18nProviderRedux messages={messages} locales={locales}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </I18nProviderRedux>
      </StoreContext.Provider>
    </SnackbarProvider>
  </Provider>,
  document.getElementById('app'),
);
if (process.browser) {
  TagManager.initialize(tagManagerArgs);
  Logger.init(SENTRY_DSN, ENV, `${SENTRY_RELEASE}`);
}
if (!IS_DEPLOYED) {
  module.hot.accept();
}

const errorReporter = function (e) {
  if (ENV === 'production' || ENV === 'staging') {
    Logger.exception(e);
  } else {
    console.error(e);
  }
};

window.addEventListener('error', errorReporter);

window.addEventListener('unhandledrejection', errorReporter);
